import {WEEKDAYS} from './dateTimeLists';

/**
 * Return the next Date for a scheduled Report runtime
 *
 * @param formValues
 * @param nowDate
 * @returns {Date}
 */
export const getNextScheduledDate = (formValues, nowDate) => {
    const val = JSON.parse(JSON.stringify(formValues));
    let nowTime = nowDate.getTime();
    let nowWeekdayIdx = nowDate.getDay();

    // Assemble frequency of Report scheduling
    let nextWeekdayIdx = nowWeekdayIdx;
    if (val.runAtType === 'weekly') {
        nextWeekdayIdx = WEEKDAYS.findIndex(r => r.id === val.runAtWeekday);
    }

    let nowHrMS = (nowDate.getHours() * 3600000);
    let nowMinMS = (nowDate.getMinutes() * 60000);
    let nextHrMS = (parseInt(val.runAtHour, 10) * 3600000);
    let nextMinMS = 0;
    let nextTime;
    let nextDate = new Date();
    let setHoursAndMinutes = false;

    if (val.runAtType === 'weekly') {
        let daysToNext = nextWeekdayIdx - nowWeekdayIdx;
        if (nextWeekdayIdx === nowWeekdayIdx) {
            // Next Weekday is today:
            if ((nextHrMS + nextMinMS) >= (nowHrMS + nowMinMS)) {
                // Set scheduled time to later today
                nextTime = nowTime + ((nextHrMS - nowHrMS) + (nextMinMS - nowMinMS));
                nextDate.setTime(nextTime);
            } else {
                // Set to next weekday instance
                nextDate.setTime(nextDate.getTime() + (86400000 * 7));
                setHoursAndMinutes = true;
            }
        } else if (nextWeekdayIdx > nowWeekdayIdx) {
            // Next Weekday is later this week; use this week
            nextDate.setTime(nextDate.getTime() + (86400000 * daysToNext));
            setHoursAndMinutes = true;
        } else if (nextWeekdayIdx < nowWeekdayIdx) {
            // Next Weekday has passed; use next week
            daysToNext = nextWeekdayIdx + (7 - nowWeekdayIdx);
            nextDate.setTime(nextDate.getTime() + (86400000 * daysToNext));
            setHoursAndMinutes = true;
        }
    } else if (val.runAtType === 'daily') {
        if ((nextHrMS + nextMinMS) >= (nowHrMS + nowMinMS)) {
            // Set next Daily scheduled time to later today
            nextTime = nowTime + ((nextHrMS - nowHrMS) + (nextMinMS - nowMinMS));
            nextDate.setTime(nextTime);
        } else {
            // Set next Daily scheduled time to next day
            nextDate.setTime(nextDate.getTime() + 86400000);
            setHoursAndMinutes = true;
        }
    }
    if (setHoursAndMinutes) {
        nextDate.setHours(parseInt(val.runAtHour, 10));
        nextDate.setMinutes(0);
    }

    return nextDate;
};

/**
 * Return expiration Date for a scheduled Report
 *
 * @param formValues
 * @returns {Date}
 */
export const getScheduledReportExpirationDate = (formValues) => {
    let expDate = new Date();
    if (!formValues) {
        return expDate;
    }
    const val = JSON.parse(JSON.stringify(formValues));
    let dateArr;
    if (val.dateRangeType === 'relative' && val.dateExpires) {
        // Relative Date Range uses the selected Expiration date
        dateArr = val.dateExpires.split('-');
        expDate.setFullYear(parseInt(dateArr[0], 10));
        expDate.setHours(parseInt(val.runAtHour, 10));
        expDate.setMinutes(0);
        expDate.setDate(parseInt(dateArr[2], 10));
        expDate.setMonth(parseInt(dateArr[1], 10) - 1);
    } else if (val.dateRangeType === 'specific') {
        // Specific Date Range calculates Expiration after next runtime after End Date
        let nowDate = new Date();
        dateArr = val.dateEnd.split('-');
        nowDate.setFullYear(parseInt(dateArr[0], 10));
        nowDate.setHours(parseInt(val.runAtHour, 10));
        nowDate.setMinutes(0);
        nowDate.setDate(parseInt(dateArr[2], 10));
        nowDate.setMonth(parseInt(dateArr[1], 10) - 1);
        // If End Date is before current date, update it:
        let todayDate = new Date();
        let nowTime = nowDate.getTime();
        if (nowTime < todayDate.getTime()) {
            nowDate.setTime(nowTime + (todayDate.getTime() - nowTime));
        }
        let nowWeekdayIdx = nowDate.getDay();
        let nextWeekdayIdx = nowWeekdayIdx;
        if (formValues.runAtType === 'weekly') {
            nextWeekdayIdx = WEEKDAYS.findIndex(r => r.id === formValues.runAtWeekday);
        }
        if (val.runAtType === 'weekly') {
            let nextDate = getNextScheduledDate(formValues, nowDate);
            let nextTime = nextDate.getTime();
            if (nextTime < nowDate.getTime()) {
                nextDate.setTime(nextTime + (nowDate.getTime() - nextTime));
            }
            if (nextWeekdayIdx === nowWeekdayIdx) {
                expDate.setTime(nextDate.getTime() + (86400000 * 7));
            } else {
                expDate.setTime(nextDate.getTime() + (86400000 * 2));
            }
        } else if (val.runAtType === 'daily') {
            expDate.setTime(nowDate.getTime() + (86400000 * 2));
        }
    }
    return expDate;
};

/**
 * Get the Date Range object from a Scheduled Report payload
 *
 * @param props
 * @returns {{fromDay: string, tz: *, toDay: string, daysBack: number}}
 */
export const getPayloadDateRangeFromProps = (props) => {
    return (props.record && props.record.payload && props.record.payload.dateRange) ? props.record.payload.dateRange : {};
};

/**
 * Get the Location object from a Scheduled Report payload
 *
 * @param props
 * @returns {*}
 */
export const getPayloadLocationFromProps = (props) => {
    return (props.record && props.record.payload && props.record.payload.location) ? props.record.payload.location : {};
};


// WEBPACK FOOTER //
// ./src/Fuse/shared/scheduledReportFunctions.js